export default "__VITE_ASSET__DlzuE5Qw__"